import { render } from "./FullBodyAvatar.vue?vue&type=template&id=10b7a904"
import script from "./FullBodyAvatar.vue?vue&type=script&lang=js"
export * from "./FullBodyAvatar.vue?vue&type=script&lang=js"

import "./FullBodyAvatar.vue?vue&type=style&index=0&id=10b7a904&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__